import ControllerBase from '../../../../global/js/ControllerBase'
import {fromEvent} from 'rxjs'

export default class ControllerDownload extends ControllerBase {

    private readonly componentRefs = {
        downloadLinkClass: 'download'
    };

    constructor(element: HTMLElement) {
        super(element);

        this.removeEventlisteners();
    }

    private removeEventlisteners(): void {
        const downloadLinks = document.querySelectorAll('a.' + this.componentRefs.downloadLinkClass);

        downloadLinks && downloadLinks.forEach((element) => {
            element && fromEvent(element, 'click').subscribe(event => {
                event.stopPropagation()
            })
        })
    }

}
